import { render, staticRenderFns } from "./DiscoverList.vue?vue&type=template&id=05ddd32b&scoped=true"
import script from "./DiscoverList.vue?vue&type=script&lang=js"
export * from "./DiscoverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ddd32b",
  null
  
)

export default component.exports